import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchMyCircles } from "../../store/my_circles/operations";
import { navigate } from "../../store/navigation/operations";
import { Translate, I18n } from "react-redux-i18n";
import { loggedInUserGuid } from "../../store/iam/selectors";
import TranslatedPage from "../../containers/TranslatedPage/TranslatedPage";

import { getCircles, loadingInitialCirclesList } from "../../store/my_circles/selectors";
import { fetchUser } from "../../store/users/operations";
import { getUserWithId, isUpdatingUser, isSuperUser } from "../../store/users/selectors";
import LoadingIndicator from "../../components/LoadingIndicator";

import { AnchorButton, Button, NonIdealState, Dialog } from "@blueprintjs/core";
import UserPublicProfile from "../../components/UserPublicProfile";
import CreateNewCircleDecorator from "../CreateNewCircleDecorator";
import KreditzLogo from "../../styles/images/kreditz-logo.png";
class UserPublicProfileContainer extends Component {
  state = {
    isOpen: false,
  };
  handleOpen = () => {
    this.setState({ isOpen: true });
  };

  handleClose = () => {
    this.setState({ isOpen: false });
  };
  componentDidMount() {
    this.props.fetchMyCircles();
    this.props.fetchUser(this.props.userId);
  }

  circleCardClicked = (circle) => {
    if (circle.status === "pending") {
      this.props.navigate(`/circle/${circle.guid}`);
    } else {
      this.props.navigate(`/circle-toolbox/${circle.guid}`);
    }
  };

  render() {
    return (
      <div className="content-wrapper has-sidebar">
        {this.props.isLoading && <LoadingIndicator />}
        {!this.props.isLoading && this.props.user_profile && (
          <UserPublicProfile user={this.props.user_profile} myGuid={this.props.myGuid} />
        )}
        <div className="sidebar-content">
          {this.props.user_profile && false && (
            <h1 className="sidebar-heading">
              {this.props.user_profile.f_name}
              <Translate value="public_profile.user_circles" />
            </h1>
          )}

          <h1 className="sidebar-heading">
            <Translate value="public_profile.sidebar_right_heading" />
          </h1>
          {this.props.loggedAsSuperUser &&
            <div className="blocked-card-list my-circles public-circles">
              {this.props.user_profile && (
                <div className="custom-card">
                  <NonIdealState
                    icon="new-object"
                    title={`${this.props.user_profile.f_name} ${I18n.t("public_profile.not_in_circles")}`}
                    description={I18n.t("public_profile.create_circle_with_him")}
                    action={
                      <CreateNewCircleDecorator empty_circle>
                        <Button intent="primary" fill={false}>
                          <Translate value="public_profile.create_circle" />
                        </Button>
                      </CreateNewCircleDecorator>
                    }
                  />
                </div>
              )}
            </div>
          }
          <div className="blocked-card-list no-top-margin">
            <div className="custom-card">
              <NonIdealState
                icon={
                  <div className="kreditz-logo non-ideal-state">
                    <img src={KreditzLogo} alt="Kreditz Logo" />
                  </div>
                }
                title={<TranslatedPage path="kreditz.title" />}
                description={<TranslatedPage path="kreditz.heading" />}
                action={
                  <Button intent="primary" fill={false} onClick={this.handleOpen}>
                    <TranslatedPage path="kreditz.subheading" />
                  </Button>
                }
              />

              <Dialog
                onClose={this.handleClose}
                title={<TranslatedPage path="kreditz.subheading" />}
                autoFocus={true}
                canEscapeKeyClose={true}
                canOutsideClickClose={true}
                enforceFocus={true}
                isOpen={this.state.isOpen}
                usePortal={true}>
                <div className="dialog-wrapper">
                  <h4 className="no-top-margin mg-b-8">
                    <TranslatedPage path="kreditz.meta_title" />
                  </h4>
                  <TranslatedPage path="kreditz.content" />
                  <AnchorButton
                    intent="primary"
                    fill={true}
                    target="_blank"
                    href="https://kreditz.com/sv/?utm_source=ihopa&utm_medium=ihopaCTA&utm_campaign=ihopa">
                    <TranslatedPage path="kreditz.meta_description" />
                  </AnchorButton>
                </div>
              </Dialog>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, own_props) => {
  return {
    myGuid: loggedInUserGuid(state),
    loading: loadingInitialCirclesList(state),
    circles: getCircles(state),
    user_profile: getUserWithId(state, own_props.userId),
    isLoading: isUpdatingUser(state, own_props.userId),
    loggedAsSuperUser: isSuperUser(state, loggedInUserGuid(state))
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchMyCircles: (id) => dispatch(fetchMyCircles()),
  navigate: (to) => dispatch(navigate(to)),
  fetchUser: (id) => dispatch(fetchUser(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserPublicProfileContainer);